var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 6,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New home + mobile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-848 -389C-848 -390.105 -847.105 -391 -846 -391H1188C1189.1 -391 1190 -390.105 1190 -389V2059C1190 2060.1 1189.1 2061 1188 2061H-846C-847.105 2061 -848 2060.1 -848 2059V-389Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-846 -390H1188V-392H-846V-390ZM1189 -389V2059H1191V-389H1189ZM1188 2060H-846V2062H1188V2060ZM-847 2059V-389H-849V2059H-847ZM-846 2060C-846.552 2060 -847 2059.55 -847 2059H-849C-849 2060.66 -847.657 2062 -846 2062V2060ZM1189 2059C1189 2059.55 1188.55 2060 1188 2060V2062C1189.66 2062 1191 2060.66 1191 2059H1189ZM1188 -390C1188.55 -390 1189 -389.552 1189 -389H1191C1191 -390.657 1189.66 -392 1188 -392V-390ZM-846 -392C-847.657 -392 -849 -390.657 -849 -389H-847C-847 -389.552 -846.552 -390 -846 -390V-392Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Home",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1128,
    transform: "translate(-809 -252)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 400"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-160 -13H10V19H-160V-13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 18H-160V20H10V18Z",
    fill: "#2E4964",
    mask: "url(#path-3-inside-1_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 113",
    d: "M1 1L5.5 5L10 1",
    stroke: "#B5B5B5"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1128,
    fill: "white",
    transform: "translate(-809 -252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowSelect);
export default __webpack_public_path__ + "static/media/down_arrow_select.4d290547d45735c6d080d5dcf6f22f86.svg";
export { ForwardRef as ReactComponent };